import { AnyAction } from '@reduxjs/toolkit'

import { PayloadActionWithError } from './PayloadActionWithError'

export const isClearAccount =
  () =>
  (action: AnyAction): action is PayloadActionWithError =>
    action.type === 'clearAccount'
